export default {
  type: "",
  data: {},
  deleted: {},
  update: {},
  add: {},
  error: ""
};
